var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5559V4.44419C11 4.0385 11.5343 3.89051 11.743 4.23839L13.8765 7.79426C13.9525 7.92093 13.9525 8.07918 13.8765 8.20586L11.743 11.7617C11.5343 12.1096 11 11.9616 11 11.5559Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83431 5.00006H0.4C0.179086 5.00006 0 5.17914 0 5.40006V10.6001C0 10.821 0.179086 11.0001 0.4 11.0001H3.83431C3.9404 11.0001 4.04214 11.0422 4.11716 11.1172L8.31716 15.3172C8.56914 15.5692 9 15.3907 9 15.0344V0.965744C9 0.609382 8.56914 0.430914 8.31716 0.6829L4.11716 4.8829C4.04214 4.95792 3.9404 5.00006 3.83431 5.00006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volume-icon.528c924ff12476e8d75a8a3f0f25b835.svg";
export { ForwardRef as ReactComponent };